// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { JenisDokumenDetailResponse } from "./types";

import * as jenisDokumenActions from "./jenisDokumen.actions";

export function* getJenisDokumen(
  action: ReturnType<typeof jenisDokumenActions.getDetailJenisDokumenAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = `${BASE_URL}jenis-dokumen/${action.payload.id}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: JenisDokumenDetailResponse = yield call(result.json.bind(result));
      yield put(jenisDokumenActions.getDetailJenisDokumenAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisDokumenActions.getDetailJenisDokumenAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(jenisDokumenActions.getDetailJenisDokumenAsync.failure(parsed));
  }
}

export default function* jenisDokumenSagaGetDetailJenisDokumen() {
  yield takeEvery(jenisDokumenActions.getDetailJenisDokumenAsync.request, getJenisDokumen);
}
